export default __webpack_public_path__ + "images/8719521d27b1cad765e59b2a335b2103.svg";